<sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" class="no-field-space add-catalog-dialog">
    <sc-dialog-title>
        {{ 'Add project' | translate: ['erp.ui.add-project.title', translationService.language]}}
    </sc-dialog-title>
    <sc-separator-line></sc-separator-line>

    <sc-flex-fitting-content [vertical]="true" class="no-field-space">
        <sc-master-detail [data]="listEntries" [readOnly]="true" [selection]="[selectedEntry]"
            (selectionChanged)="handleSelectionChange($event)">
            <ng-container *ngIf="selectedIndex===TAB_INDEX_SELECT_PROJECT">
                <app-project-selection (projectSelected)="onProjectAdded($event)"></app-project-selection>
            </ng-container>
            <sc-padding [fitHeight]="true">
                <ng-container *ngIf="selectedIndex===TAB_INDEX_ADD_PROJECT">
                    <app-add-project-editor (projectAdded)="onProjectAdded($event)"></app-add-project-editor>
                </ng-container>
            </sc-padding>
        </sc-master-detail>
    </sc-flex-fitting-content>

    <sc-separator-line></sc-separator-line>
    <sc-actionbar>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="onCancel()">
            {{ 'Abbrechen' | translate: ['erp.ui.add-project.action.cancel', translationService.language]}}
        </button>
    </sc-actionbar>
</sc-flex>
